import React from 'react';

import { DialogContext } from '@cvt/contexts';

import { Authenticated } from '@modules/Auth/components';
import { InviteTeamMemberDialog } from '@modules/Users/dialogs/InviteTeamMember';
import { EditLeadershipValuesDialog } from '@modules/Objectives/dialogs/EditLeadershipValuesDialog';
import { EditCommunicationObjectivesDialog } from '@modules/Objectives/dialogs/EditCommunicationObjectivesDialog';
import { LinkStoriesToMeetingDialog } from '@modules/Meetings/dialogs/LinkStoriesToMeetingDialog';
import { CreateMeetingFeedbackDialog } from '@modules/Meetings/dialogs/CreateMeetingFeedbackDialog';
import { EditMeetingFeedbackDialog } from '@modules/Meetings/dialogs/EditMeetingFeedbackDialog';
import { StructuralAnalysisDialog } from '@modules/Analysis/dialogs/StructuralAnalysisDialog';
import { SupportCharacterDialog } from '@modules/Stories/dialogs/SupportCharacterDialog';



export const Dialogs = () => {
  const { openedDialogs, closeDialog, dialogOptions } = React.useContext(DialogContext);
  return (
    <React.Fragment>
      <Authenticated>
        <InviteTeamMemberDialog open={!!openedDialogs['inviteTeamMember']} onClose={() => closeDialog('inviteTeamMember')}/>

        {!!openedDialogs['editLeadershipValues'] && (
          <EditLeadershipValuesDialog open onClose={() => closeDialog('editLeadershipValues')} options={dialogOptions?.editLeadershipValues}/>
        )}
        {!!openedDialogs['editCommunicationObjectives'] && (
          <EditCommunicationObjectivesDialog open onClose={() => closeDialog('editCommunicationObjectives')} options={dialogOptions?.editCommunicationObjectives}/>
        )}
        {!!openedDialogs['meetingLinkStories'] && (
          <LinkStoriesToMeetingDialog open onClose={() => closeDialog('meetingLinkStories')} options={dialogOptions?.meetingLinkStories}/>
        )}
        {!!openedDialogs['createMeetingFeedback'] && (
          <CreateMeetingFeedbackDialog open onClose={() => closeDialog('createMeetingFeedback')} options={dialogOptions?.createMeetingFeedback}/>
        )}
        {!!openedDialogs['editMeetingFeedback'] && (
          <EditMeetingFeedbackDialog open onClose={() => closeDialog('editMeetingFeedback')} options={dialogOptions?.editMeetingFeedback}/>
        )}
        {!!openedDialogs['structuralAnalysis'] && (
          <StructuralAnalysisDialog open onClose={() => closeDialog('structuralAnalysis')} options={dialogOptions?.structuralAnalysis}/>
        )}
        {!!openedDialogs['supportCharacter'] && (
          <SupportCharacterDialog 
            open 
            onClose={() => closeDialog('supportCharacter')} 
            onSubmit={dialogOptions?.supportCharacter?.onSubmit} 
            character={dialogOptions?.supportCharacter?.character}
            options={dialogOptions?.supportCharacter}
          />
        )}
      </Authenticated>
    </React.Fragment>
  );
};
